// returns a blob url of the preloaded media

import axios from 'axios'

const fetchMedia = async url => {
  const response = await axios.get(url, { responseType: 'blob' })
  if (response.status !== 200) console.error('Error fetching media')
  else console.log('Media loaded'); return URL.createObjectURL(response.data)
}

export default fetchMedia
